export const companiesToSeeSnapchatBanner = [
  '02jpBGXL',
  'W0RnmGqZ',
  'K8j35EGr',
  'ApRg23GK',
  '4KjW8wM1',
  'OWMOnejy',
  '02jpxkjX',
  'KXReyqRq',
  'PeG7Agjb',
  'DPG4gxM8',
  'AxGxnQjP',
  'K8j38eMr',
  '3dGq1mGa',
  'aJGr4ojy',
  'xwMBNvMB',
  'yBMd0bM6',
  '7zMZvPMQ',
  'K8j3leMr',
  '18jAzJMJ',
  '7zMZJMQN',
  '3dGqDrMa',
  'ApRgVdGK',
  'ZVjEv5ML',
  'KXRekeMq',
  'BejNmdR9',
  '7zMZwPGQ',
  'dyj6OpML',
  'aJGr6BGy',
  '02jpOoRX',
  'a4jPeWM2',
  '7bMaWeRp',
  'nB2j15Y1',
]
